import { Typography } from "@mui/material";
import { TFunction } from "i18next";
import snakeCase from "lodash/snakeCase";
import capitalize from "lodash/capitalize";

import {
  Avatar,
  ComplexListItemProps,
  formatDate,
} from "@inductiveautomation/ws-components";

import {
  CertificationActionCallback,
  Certification,
  ElectiveWithType,
} from "../Training.types";
import { getHistoryActions } from "../Training.actionsForState";

const dateInfo = (date?: Date) => (date ? formatDate(date, "date") : "-");

export const getHistoricalCredentials = (
  t: TFunction,
  certification: Exclude<Certification, ElectiveWithType> | undefined,
  onAction: CertificationActionCallback,
  {
    tsAccountCertificateDownloadFe,
    tsAccountTrainingBadgeDownloadFe,
  }: {
    tsAccountCertificateDownloadFe: boolean;
    tsAccountTrainingBadgeDownloadFe: boolean;
  }
): ComplexListItemProps[] => {
  const certifications = certification?.history ?? [];
  return certifications.map((certification) => {
    const name = t("training.credential_name", {
      versionNumber: certification.version,
    });
    return {
      id: snakeCase(`historical-credential-${name})}`),
      testId: snakeCase(name.toLowerCase()),
      avatar: (
        <Avatar
          imageUrl={certification.iconUrl}
          variant={"image"}
          imageUrlRemoveBorderRadius
        />
      ),
      heading: name,
      ...(certification.earnDate
        ? {
            info: (
              <Typography variant="body2">
                {dateInfo(new Date(certification.earnDate))}
              </Typography>
            ),
          }
        : {}),
      actionLists: getHistoryActions(t, onAction, {
        tsAccountCertificateDownloadFe,
        tsAccountTrainingBadgeDownloadFe,
      }),
    };
  });
};

export const getHistoricalCoreCertifications = (
  t: TFunction,
  certification: Exclude<Certification, ElectiveWithType> | undefined,
  onAction: CertificationActionCallback,
  {
    tsAccountCertificateDownloadFe,
    tsAccountTrainingBadgeDownloadFe,
  }: {
    tsAccountCertificateDownloadFe: boolean;
    tsAccountTrainingBadgeDownloadFe: boolean;
  }
): ComplexListItemProps[] => {
  const certifications = certification?.history ?? [];

  return certifications.map((certification) => {
    const name = t("training.core_name", {
      versionNumber: certification.version,
    });
    return {
      id: snakeCase(`historical-credential-${name})}`),
      testId: snakeCase(name.toLowerCase()),
      avatar: (
        <Avatar
          imageUrl={certification.iconUrl}
          variant={"image"}
          imageUrlRemoveBorderRadius
        />
      ),
      heading: name,
      subtext: capitalize(certification.earnMethod),
      ...(certification.earnDate
        ? {
            info: (
              <Typography variant="body2">
                {dateInfo(new Date(certification.earnDate))}
              </Typography>
            ),
          }
        : {}),
      actionLists: getHistoryActions(t, onAction, {
        tsAccountCertificateDownloadFe,
        tsAccountTrainingBadgeDownloadFe,
      }),
    };
  });
};

export const getHistoricalGoldCertifications = (
  t: TFunction,
  certification: Exclude<Certification, ElectiveWithType> | undefined,
  onAction: CertificationActionCallback,
  {
    tsAccountCertificateDownloadFe,
    tsAccountTrainingBadgeDownloadFe,
  }: {
    tsAccountCertificateDownloadFe: boolean;
    tsAccountTrainingBadgeDownloadFe: boolean;
  }
): ComplexListItemProps[] => {
  const certifications = certification?.history ?? [];

  return certifications.map((certification) => {
    const name = t("training.gold_name", {
      versionNumber: certification.version,
    });
    return {
      id: snakeCase(`historical-credential-${name})}`),
      testId: snakeCase(name.toLowerCase()),
      avatar: (
        <Avatar
          imageUrl={certification.iconUrl}
          variant={"image"}
          imageUrlRemoveBorderRadius
        />
      ),
      heading: name,
      subtext: capitalize(certification.earnMethod),
      ...(certification.earnDate
        ? {
            info: (
              <Typography variant="body2">
                {dateInfo(new Date(certification.earnDate))}
              </Typography>
            ),
          }
        : {}),
      actionLists: getHistoryActions(t, onAction, {
        tsAccountCertificateDownloadFe,
        tsAccountTrainingBadgeDownloadFe,
      }),
    };
  });
};
